module.exports = __webpack_public_path__ + "media/images/app/colors/colors-white-4f3d06cb08dda9c462e1bc85b836d74c.webp";